import React from "react";
import { MapPin, ExternalLink } from "lucide-react";

// Free embed (no API key). Uses Google's standard maps embed URL.
export default function MapEmbed({ latitude, longitude, label = "Location", height = 260 }) {
  if (!latitude || !longitude) return null;
  const src = `https://maps.google.com/maps?q=${latitude},${longitude}&z=15&output=embed`;
  const externalHref = `https://www.google.com/maps?q=${latitude},${longitude}`;
  return (
    <div className="rounded-md overflow-hidden border border-brand-border bg-white" data-testid="map-embed">
      <iframe
        title={label}
        src={src}
        height={height}
        className="w-full"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
      <div className="px-3 py-2 border-t border-brand-border flex items-center justify-between text-xs">
        <span className="inline-flex items-center gap-1 text-brand-muted">
          <MapPin className="h-3.5 w-3.5 text-brand-accent" />
          {Number(latitude).toFixed(5)}, {Number(longitude).toFixed(5)}
        </span>
        <a href={externalHref} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-brand-primary font-medium hover:underline">
          Open in Google Maps <ExternalLink className="h-3 w-3" />
        </a>
      </div>
    </div>
  );
}
